import api from './api';

export interface Profile {
  id: string;
  username: string;
  email: string;
  fullName: string;
  phoneNumber: string;
  department: string;
  jobTitle: string;
  role: string;
  tenant: string;
  userId: string;
  lastLogin: string;
  profilePicture?: string | null;
}

export interface ProfileUpdateData {
  email?: string;
  fullName?: string;
  phoneNumber?: string;
  department?: string;
  jobTitle?: string;
}

export interface ChangePasswordData {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface AccountSettings {
  language: string;
  timeZone: string | null;
  dateFormat: string | null;
  timeFormat: string | null;
  theme: string;
  emailNotifications: boolean;
  deviceAlerts: boolean;
  securityAlerts: boolean;
  weeklyReports: boolean;
  marketingCommunications: boolean;
  twoFactorEnabled: boolean;
  passwordLastChanged: string;
}

export interface AccountSettingsUpdateData {
  language?: string;
  timeZone?: string | null;
  dateFormat?: string | null;
  timeFormat?: string | null;
  theme?: string;
  emailNotifications?: boolean;
  deviceAlerts?: boolean;
  securityAlerts?: boolean;
  weeklyReports?: boolean;
  marketingCommunications?: boolean;
  twoFactorEnabled?: boolean;
}

const profileService = {
  /**
   * Get current user's profile
   */
  getProfile: async (): Promise<Profile> => {
    const response = await api.get('/profile');
    return (response as any).data;
  },

  /**
   * Update current user's profile
   */
  updateProfile: async (data: ProfileUpdateData): Promise<Profile> => {
    const response = await api.put('/profile', data);
    return (response as any).data;
  },

  /**
   * Change password
   */
  changePassword: async (data: ChangePasswordData): Promise<{ message: string }> => {
    const response = await api.post('/profile/change-password', data);
    return (response as any).data;
  },

  /**
   * Get account settings
   */
  getSettings: async (): Promise<AccountSettings> => {
    const response = await api.get('/profile/settings');
    return (response as any).data;
  },

  /**
   * Update account settings
   */
  updateSettings: async (data: AccountSettingsUpdateData): Promise<AccountSettings> => {
    const response = await api.put('/profile/settings', data);
    return (response as any).data;
  },

  /**
   * Delete account
   */
  deleteAccount: async (): Promise<{ message: string }> => {
    const response = await api.delete('/profile');
    return (response as any).data;
  },
};

export default profileService;

